export default {
    PLACE: 'PLACE',
    HEALTH_CARD: 'HEALTH_CARD',
    SEARCH_VALUE: 'SEARCH_VALUE',
    PARTIES_MES: 'PARTIES_MES',
    SELFINFO: 'SELFINFO',
    FILE_LIST: 'FILE_LIST',
    FILE_IMAGES: 'FILE_IMAGES'
};
